export { default } from "./DashboardTemplate"
